import React from 'react'
import { Box, Typography } from '@mui/material/'

type Category = {
  name: string | null
  description?: string | null
}

type Props = {
  category: Partial<Category> | null | undefined
}

export const CategoryMainInfo: React.VFC<Props> = (props) => (
  <Box pt={1} pb={1}>
    <Typography variant="h5">{props.category?.name}</Typography>
    <Typography>{props.category?.description}</Typography>
  </Box>
)
